<button
  class="btn paging-button shadow btn-ripple"
  aria-label="previous"
  type="button"
  (click)="onPaging(previousOffset)"
  [disabled]="disablePrevious"
>
  <i class="fa fa-angle-left"></i>
  Prev
</button>
<button
  class="btn paging-button shadow primary btn-ripple"
  aria-label="next"
  type="button"
  (click)="onPaging(nextOffset)"
  [disabled]="nextOffset === '-1'"
>
  Next
  <i class="fa fa-angle-right"></i>
</button>
